import React, { Suspense, lazy, useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { config } from './components/pages/config';
import Loader from './components/common/Loader';

const HomePage = lazy(() => import('./components/pages/Home'));
const AboutIndex = lazy(() => import('./components/pages/About'));
const ServiceIndex = lazy(() => import('./components/pages/Services'));
const ContactIndex = lazy(() => import('./components/pages/Contact'));
const ServiceDetails = lazy(() =>
  import('./components/pages/Services/ServiceDetails')
);
const NewsList = lazy(() => import('./components/pages/News/NewsList'));
const NewsDetails = lazy(() => import('./components/pages/News/NewsDetails'));
const NotFound = lazy(() => import('./components/common/NotFound'));
const CaseStudy = lazy(() => import('./components/pages/CaseStudy/CaseStudy'));
const CaseDetail = lazy(() =>
  import('./components/pages/CaseStudy/CaseDetail')
);
const Privacy = lazy(() => import('./components/pages/Company-Pages/Privacy'));
const Terms = lazy(() =>
  import('./components/pages/Company-Pages/Terms-Condiitons')
);

const AllRoutes = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [location.pathname]);

  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about-us" element={<AboutIndex />} />
        <Route path="/services" element={<ServiceIndex />} />
        <Route path="/service/:slug" element={<ServiceDetails />} />
        <Route path="/contact-us" element={<ContactIndex />} />
        <Route path="/case-studies" element={<CaseStudy />} />
        <Route path="/case-study/:slug" element={<CaseDetail />} />
        <Route path="/news-and-update" element={<NewsList />} />
        <Route path="/news/:slug" element={<NewsDetails />} />
        <Route path="/privacy-policy" element={<Privacy />} />
        <Route path="/terms-conditions" element={<Terms />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
};

export default AllRoutes;
